module.exports = __webpack_public_path__ + "static/push-bg-ac95c7712e418d1e3ea44b72daeb06a4.png";